// extracted by mini-css-extract-plugin
export default {"container":"src-pages-SalesChannelCategory-Components-Card-css-module__container--ebAEE","editBtn":"src-pages-SalesChannelCategory-Components-Card-css-module__editBtn--hzRl-"};